import React, { useMemo } from "react";
import { ReactifyChartColors } from "Util/ReactifyChartColors";

const colors = ReactifyChartColors();

import Chart from "react-apexcharts";

function RadarMultipleSeries() {
  const { options, series } = useMemo(
    () => ({
      options: {
        colors: [colors.ReactifyChartColor1, colors.ReactifyChartColor2],
        chart: {
          dropShadow: {
            enabled: true,
            blur: 1,
            left: 1,
            top: 1
          }
        },
        labels: ["Glasses", "Shoes", "Shirts", "Jackets", "Coat", "T-Shirts"],
        stroke: {
          width: 2
        },
        fill: {
          opacity: 0
        },
        markers: {
          size: 0
        }
      },
      series: [
        {
          name: "Glasses",
          data: [80, 50, 30, 40, 100, 20]
        },
        {
          name: "T-Shirts",
          data: [20, 30, 40, 80, 20, 80]
        }
      ]
    }),
    []
  );

  return (
    <Chart
      options={options}
      series={series}
      type="radar"
      width="100%"
      height="300px"
    />
  );
}

export default RadarMultipleSeries;
